import OrdemDeServico, {
  FinderOrdensDeServico,
  RetornoOrdemDeServico,
} from 'Interface/OS/OrdensDeServico';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'OrdensDeServico';

const url = '/ordens-de-servico';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarOrdensDeServico: construtor.query<
        FinderOrdensDeServico,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.ordens_de_servico
            ? [
                ...resultado.ordens_de_servico.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarOrdemDeServico: construtor.query<
        RetornoOrdemDeServico,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarOrdemDeServico: construtor.mutation<
        OrdemDeServico,
        Partial<OrdemDeServico>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarOrdemDeServico: construtor.mutation<
        OrdemDeServico,
        Partial<OrdemDeServico> &
          Pick<OrdemDeServico, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerOrdemDeServico: construtor.mutation<
        OrdemDeServico,
        Partial<OrdemDeServico> & Pick<OrdemDeServico, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarOrdensDeServicoQuery,
  useRecuperarOrdemDeServicoQuery,
  useAdicionarOrdemDeServicoMutation,
  useEditarOrdemDeServicoMutation,
  useRemoverOrdemDeServicoMutation,
} = apiExtendida;
